import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { StyledDiv as ArticleDate } from "~/components/article/article-author-block/article-date/default-article-date/styles";
import { ArticleTrustLabel } from "~/components/article/article-trust-label";
import { AuthorAvatar } from "~/components/author/author-avatar";
import { StyledImage as AuthorAvatarImage } from "~/components/author/author-avatar/styles";
import { StyledEntityLink as AuthorName } from "~/components/author/author-name/styles";
import { EntityFollowButton } from "~/components/entity-follow-button";
import { ZIndexLayer } from "~/lib/styles";

import { AuthorNames } from "./author-names";
import { AndSeparator, CommaSeparator } from "./author-names/styles";

type AuthorAvatarProps = {
  $zIndex: number;
};

export const StyledAuthorAvatar = styled(AuthorAvatar, { ...transientOptions })<AuthorAvatarProps>`
  position: relative;
  z-index: ${props => props.$zIndex};

  display: inline-block;

  inline-size: 60px;
  block-size: 60px;
  box-sizing: content-box;

  ${AuthorAvatarImage} {
    padding: 1px;
  }
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;

  margin-inline-end: 16px;

  ${StyledAuthorAvatar}:not(:first-child) {
    margin-inline-start: -16px;
  }
`;

type InformationContainerProps = {
  $authorsLength: number;
};
export const InformationContainer = styled.div<InformationContainerProps>`
  flex-grow: 1;

  padding-block-start: ${props => (props.$authorsLength > 1 ? "12px" : "0")};

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-start: 0;
  }
`;

export const ArticleDateAndLabelContainer = styled.div`
  display: flex;
  flex-flow: column;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-flow: row;
    justify-content: space-between;
    align-items: stretch;
  }
`;

export type ArticleAuthorBlockContainerProps = {
  $authorsLength: number;
  $variant?: "light" | "dark";
};
export const ArticleAuthorBlockContainer = styled.div<ArticleAuthorBlockContainerProps>`
  display: flex;
  flex-flow: ${props => (props.$authorsLength > 1 ? "column" : "row")};
  justify-content: flex-start;
  align-items: stretch;

  ${props => props.theme.breakpoints.up("desktop")} {
    flex-flow: row;
  }

  ${ArticleDate}, ${AuthorName}, ${CommaSeparator}, ${AndSeparator} {
    ${props =>
      props.$variant === "dark"
        ? css`
            color: #ffffff;
          `
        : null}
  }
`;

export const StyledArticleTrustLabel = styled(ArticleTrustLabel)`
  ${props => props.theme.breakpoints.only("mobile")} {
    margin-block-start: 4px;
  }
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)`
  z-index: ${ZIndexLayer.ArticleAuthorFollowButton};

  margin-block: 6px;
  margin-inline-start: 12px;
`;

export const StyledAuthorNames = styled(AuthorNames)`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 500px;
    margin-block-end: 4px;
  }
`;
